import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { convoAIAuditLogApiURL } from '../../ui/prebuilt/utils';
import { createCommand, getPluginState } from './ai-audit-log-plugin-factory';
export function sendAuditLogEvent(_x, _x2) {
  return _sendAuditLogEvent.apply(this, arguments);
}
function _sendAuditLogEvent() {
  _sendAuditLogEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event, view) {
    var pluginState, eventData, retryDelay, eventState, entityId, retrySendingEvent, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          retrySendingEvent = function _retrySendingEvent() {
            if (eventState.retries < pluginState.maxRetries) {
              setTimeout(function () {
                sendAuditLogEvent(event, view);
              }, retryDelay);
            }
          };
          /**
           * Always get pluginState from view.state as view.state is always latest state
           * 	as sendAuditLogEvent is called in recursion and depend on pluginState
           * 	updated by previous call.
           */
          pluginState = getPluginState(view.state);
          eventData = pluginState.eventData, retryDelay = pluginState.retryDelay;
          eventState = pluginState[event];
          entityId = eventData.type === 'page' ? eventData.pageId : eventData.issueId;
          updateAIAuditLogPluginState(_defineProperty({}, event, {
            retries: eventState.retries + 1
          }))(view.state, view.dispatch);
          _context.prev = 6;
          _context.next = 9;
          return fetch(convoAIAuditLogApiURL, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              event: event,
              ai_feature_input: {
                entityId: entityId
              }
            })
          });
        case 9:
          response = _context.sent;
          if (response.ok) {
            updateAIAuditLogPluginState(_defineProperty({}, event, {
              eventStatus: 'event-sent'
            }))(view.state, view.dispatch);
          } else {
            retrySendingEvent();
          }
          _context.next = 16;
          break;
        case 13:
          _context.prev = 13;
          _context.t0 = _context["catch"](6);
          retrySendingEvent();
        case 16:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[6, 13]]);
  }));
  return _sendAuditLogEvent.apply(this, arguments);
}
export var updateAIAuditLogPluginState = function updateAIAuditLogPluginState(pluginState) {
  return createCommand(function (state) {
    return {
      type: 'UPDATE_PLUGIN_STATE',
      data: pluginState
    };
  }, function (tr) {
    return tr.setMeta('addToHistory', false);
  });
};